import React from 'react';

const FEATURES = [
    { icon: '🏙️', titulo: 'Evaluación integral',  texto: 'Analiza tu ciudad en 9 dimensiones clave: hogar, movilidad, salud, participación y más.' },
    { icon: '📊', titulo: 'Resultados visuales',   texto: 'Indicadores claros con puntuaciones por categoría para la toma de decisiones.' },
    { icon: '📋', titulo: 'Informes exportables',  texto: 'Genera informes PDF con conclusiones personalizadas para compartir con tu municipio.' },
    { icon: '🤝', titulo: 'Red de municipios',     texto: 'Forma parte de una red de ciudades comprometidas con el bienestar de sus ciudadanos.' },
];

const STATS = [
    { valor: '9', label: 'Categorías'   },
    { valor: '78',    label: 'Indicadores '   },
    { valor: '100%', label: 'Datos reales' },
];

export const LoginScreen = () => {
    return (
        <>
        {/* ── HERO ── */}
        <section className="ls-hero">
            <div className="ls-hero-badge">Plataforma oficial</div>
            <h1 className="ls-hero-title">
                Ciudades más <em>humanas</em><br />y sostenibles
            </h1>
            <p className="ls-hero-sub">
                Herramienta de evaluación municipal para medir el bienestar ciudadano
                en las 9 dimensiones que más importan a las personas.
            </p>
            <div className="ls-hero-stats">
                {STATS.map((s, i) => (
                    <React.Fragment key={i}>
                        {i > 0 && <div className="ls-stat-sep" />}
                        <div>
                            <div className="ls-stat-val">{s.valor}</div>
                            <div className="ls-stat-lbl">{s.label}</div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </section>

        {/* ── FEATURES ── */}
        <section className="ls-features-section">
            <p className="ls-section-tag">¿Qué es Ciudades que Cuidan?</p>
            <h2 className="ls-section-title">Todo lo que necesitas para evaluar tu ciudad</h2>
            <div className="ls-features-grid">
                {FEATURES.map((f, i) => (
                    <div key={i} className="ls-feat-card">
                        <div className="ls-feat-icon">{f.icon}</div>
                        <div className="ls-feat-title">{f.titulo}</div>
                        <p className="ls-feat-text">{f.texto}</p>
                    </div>
                ))}
            </div>
        </section>


        </>
    );
};